module.exports = "/_next/static/images/3b0ae019fbd70cf42e89c3220914c4e5-2-woman-working@1x.jpg";